module.exports = __webpack_public_path__ + "assets/img/macos-big-sur-light.b552bd6e.jpg";